import { Routes } from '@angular/router';
import { LoginComponent } from '@verify/shared-components/components';
import { AuthGuard, AuthResolver } from '@verify/shared-components/helpers';
import { homepageGuard } from './guards';
import { LayoutComponent } from './modules/layout/layout.component';
import { ErrorComponent } from './modules/shared/error/error.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
          import('./modules/homepage/homepage.routes').then(
            (mod) => mod.homepageRoutes,
          ),
        canActivate: [homepageGuard],
      },
      {
        path: 'projects',
        loadChildren: () =>
          import('./modules/projects/projects.routes').then(
            (mod) => mod.projectsRoutes,
          ),
      },
      {
        path: 'project',
        loadChildren: () =>
          import('./modules/project/project.routes').then(
            (mod) => mod.projectRoutes,
          ),
      },
      {
        path: 'collections',
        loadChildren: () =>
          import('./modules/collections/collections.routes').then(
            (mod) => mod.collectionsRoutes,
          ),
      },
      {
        path: 'collection',
        loadChildren: () =>
          import('./modules/collection/collection.routes').then(
            (mod) => mod.collectionRoutes,
          ),
      },
      {
        path: 'asset',
        loadChildren: () =>
          import('./modules/asset/asset.routes').then((mod) => mod.assetRoutes),
      },
      {
        path: 'assets',
        loadChildren: () =>
          import('./modules/assets/assets.routes').then(
            (mod) => mod.assetsRoutes,
          ),
      },
      {
        path: 'waiting-room',
        loadChildren: () =>
          import('./modules/waiting-room/waiting-room.routes').then(
            (mod) => mod.waitingRoomRoutes,
          ),
      },
      {
        path: 'guides',
        loadChildren: () =>
          import('./modules/guides/guides.routes').then(
            (mod) => mod.guidesRoutes,
          ),
      },
      {
        path: 'guide',
        loadChildren: () =>
          import('./modules/guide/guide.routes').then((mod) => mod.guideRoutes),
      },
      {
        path: 'models',
        loadChildren: () =>
          import('./modules/models/models.routes').then(
            (mod) => mod.modelsRoutes,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.routes').then(
            (mod) => mod.settingsRoutes,
          ),
      },
      {
        path: 'error',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: 'ext',
    loadChildren: () =>
      import('./modules/external/external.routes').then(
        (mod) => mod.externalRoutes,
      ),
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: {
      ready: AuthResolver,
    },
  },
];
